export function emptySelection() {
    return { lat: null, lng: null, address: null, city: null, province: null, isValid: false, availableCities: [] };
}

/**
 * (0, 0) is "Null Island" in the Atlantic, never a real user location.
 *
 * @param {{ lat?: unknown, lng?: unknown }|null} location
 * @returns {boolean}
 */
export function hasValidCoordinates(location) {
    const isBlank = (value) => [null, undefined, ''].includes(value);

    if (!location || isBlank(location.lat) || isBlank(location.lng)) {
        return false;
    }

    const lat = Number(location.lat);
    const lng = Number(location.lng);

    return Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0);
}

/**
 * Normalises Google's LatLng objects and plain `{ lat, lng }` values to a plain literal.
 *
 * @param {google.maps.LatLng|google.maps.LatLngLiteral|{ lat: unknown, lng: unknown }} position
 * @returns {{ lat: number, lng: number }}
 */
export function toLatLngLiteral(position) {
    return typeof position.lat === 'function'
        ? { lat: position.lat(), lng: position.lng() }
        : { lat: Number(position.lat), lng: Number(position.lng) };
}
